/** The event processor matches { key, value, isExclude }, not header names alone. */
export function readHeaderRules(raw) {
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw.trim() || '[]') : (raw ?? [])
    // The settings endpoint historically used {} for an empty list.
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && Object.keys(parsed).length === 0) return []
    if (!Array.isArray(parsed)) return null
    return parsed.map((rule) => {
      // Recover names saved by the old React editor as editable rules.
      if (typeof rule === 'string') return { key: rule, value: '', isExclude: true }
      if (!rule || typeof rule !== 'object' || Array.isArray(rule)) throw new Error('Invalid rule')
      const fields = Object.fromEntries(Object.entries(rule).map(([key, value]) => [key.toLowerCase(), value]))
      if (typeof fields.key !== 'string' || (fields.value != null && typeof fields.value !== 'string')) {
        throw new Error('Invalid rule')
      }
      if (fields.isexclude != null && ![true, false, 'true', 'false'].includes(fields.isexclude)) {
        throw new Error('Invalid rule type')
      }
      return {
        key: fields.key,
        value: fields.value ?? '',
        isExclude: fields.isexclude === true || fields.isexclude === 'true',
      }
    })
  } catch {
    // Do not turn unreadable saved rules into an empty list that can overwrite them.
    return null
  }
}

export function serializeHeaderRules(rules) {
  return JSON.stringify(rules.map(({ key, value, isExclude }) => ({
    key: key.trim(),
    value, // Values are case-sensitive exact matches; preserve spaces too.
    isExclude,
  })))
}

export const isHeaderName = (key) => /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/.test(key.trim())
